import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { headingBlue, maroon, red } from '../../../assets/colors'
import { titleStyle } from '../UpdateWORKersDetails/updateWORKerDetails_css'
import CustomTextField from '../../CustomTextField'
import CustomDropDown from '../../CustomDropDown'
import { genderList, obligationList } from '../../../utils/constants'
import { buttonStyle } from '../../../utils/commonCSS'
import { addNewWORKer, getAllDistrictsForState, getAllStates } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { validateContact, validateDistrict, validateGender, validateName, validateObligation, validateState } from '../../../utils/validations'
import { errorStyleText } from '../../formStyle'
import Loader from '../../Loader'
import { useNavigate } from 'react-router-dom'

const AddNewWORKer = (props) => {
  
  const navigate = useNavigate()

  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const [contactNumber, setContactNumber] = useState('')
  const [contactError, setContactError] = useState('')
  const [gender, setGender] = useState('Gender *')
  const [genderError, setGenderError] = useState('')
  const [obligation, setObligation] = useState('Obligation *')
  const [obligationError, setObligationError] = useState('')
  const [id, setId] = useState('')
  const [idError, setIdError] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('District *')
  const [selectedDistrictError, setSelectedDistrictError] = useState('')
  const [isDistrictHead, setIsDistrictHead] = useState(false)
  const [isStateHead, setIsStateHead] = useState(false)
  const [stateList, setStateList] = useState([])
  const [selectedState, setSelectedState] = useState('State *')
  const [districtsList, setDistrictsList] = useState([])
  const [selectedStateError, setSelectedStateError] = useState('')

  const [isloader, setLoader] = useState(false)
  const [apiError, setApiError] = useState('')

  const updateContactnumber = (value) => {

    if(value?.length > 10){
      setContactError('Contact Number cannot have more than 10 digits.')
    } else {
      setContactError('')
      setContactNumber(value)
    }
  }

  const updateId = (value) => {
    if( value.length < 4 && (/^\d+$/.test(value) || value === '')){
      setId(value)
      setIdError(null)
    } else if(!/^\d+$/.test(value)){
      setIdError('Id can only have digits.')
    } else {
      setIdError('Id cannot be more than 3 digits.')
    }
  }

  function validateAdd(){
    let isValid = true

    let nameValidationResult = validateName(name, 'Name')
    if( nameValidationResult != ''){
      setNameError(nameValidationResult)
      isValid = false
    }else {
      setNameError('')
    }

    let contactValidationResult = validateContact(contactNumber)
    if( contactValidationResult != ''){
      setContactError(contactValidationResult)
      isValid = false
    } else {
      setContactError('')
    }

    let genderValidationResult = validateGender(gender)
    if( genderValidationResult != ''){
      setGenderError(genderValidationResult)
      isValid = false
    } else  {
      setGenderError('')
    }

    let obligationValidationResult = validateObligation(obligation)
    if( obligationValidationResult != ''){
      setObligationError(obligationValidationResult)
    } else {
      setObligationError('')
    }

    let distictValidationResult = validateDistrict(selectedDistrict)
    if(distictValidationResult != ''){
      setSelectedDistrictError(distictValidationResult)
      isValid = false
    } else {
      setSelectedDistrictError('')
    }

    let stateValidationResult = validateState(selectedState)
    if( stateValidationResult != ''){
      setSelectedStateError(stateValidationResult)
    } else {
      setSelectedStateError('')
    }

    return isValid

  }

  const addWORKer = () => {
    try{
      setLoader(true)
      let validationResult = validateAdd()

      if( validationResult) {
        let options = {
          url: addNewWORKer,
          method: 'POST',
          payload: {
            name: name,
            contactNumber: contactNumber,
            gender: gender,
            obligation: obligation,
            id: id,
            district: selectedDistrict,
            state: selectedState,
            isDistrictHead: isDistrictHead,
            isStateHead: isStateHead
          },
          headers: {
            headers: {
              Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
            }
          }
        }

        HttpService(options).then(() => {
          setLoader(false)
          props.updateFunc(false, true)
        }).catch(err => {
          if(err?.status === 403){
            localStorage.clear()
            setLoader(false)
            navigate('/Login')
          } else {
            console.log('Error in adding New WORKer: ', err)
            setApiError(err?.response?.data?.message)
            setLoader(false)
          }
          
        })
      } else {
        setLoader(false)
      }

    } catch(err){
      console.log("Error in adding WORKer: ", err)
    }
  }

  useEffect(() => {
    setName('')
    setNameError('')
    setContactNumber('')
    setContactError('')
    setGender('Gender *')
    setGenderError('')
    setObligation('Obligation *')
    setObligationError('')
    setId('')
    setIdError('')
    setSelectedDistrict('District *')
    setSelectedDistrictError('')
    setIsDistrictHead(false)
    setIsStateHead(false)
    setSelectedState('State *')
    setDistrictsList([])
    setSelectedStateError('')
    setApiError('')
  }, [props.dialogStatus])


  useEffect(() => {
    try{
      if(props.dialogStatus){
        setLoader(true)
        let options = {
          url: getAllStates,
          method: 'GET',
          headers: {
            authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
        HttpService(options).then((resp) => {
          setLoader(false)
          setStateList(resp?.data?.data)
        }).catch(err => {
          if(err?.status === 403){
            localStorage.clear()
            setLoader(false)
            navigate('/Login')
          } else {
            console.log('Error in fetching all states: ', err)
            setApiError('Error in fetching states. Please contact support.')
            setLoader(false)
          }
        })
      }

    } catch(err){
      console.log('Error in fetching all the states: ', err)
      setLoader(false)
    }
  }, [props.dialogStatus])

  useEffect(() => {
    try{
      if( selectedState != 'State *'){
        setLoader(true)
        let options = {
          url: getAllDistrictsForState,
          method: 'GET',
          params: {
            state: selectedState
          },
          headers:{
            authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }

        HttpService(options).then(resp => {
          setDistrictsList(resp?.data?.data)
          setLoader(false)
        }).catch(err => {
          if(err?.status === 403){
            localStorage.clear()
            setLoader(false)
            navigate('/Login')
          } else {
            console.log('Error in fetching all districts: ', err)
            setApiError('Error in fetching districts. Please contact support.')
            setLoader(false)
          }
        })
      }
    } catch(err){
      console.log('Error in fetching districts: ', err)
      setLoader(false)
    }
  }, [selectedState])

  return (
    <>
        <Dialog maxWidth='xs' fullWidth open={props.dialogStatus} onClose={() => props.updateFunc(false)}>
            <DialogTitle style={titleStyle}>
                Add New WORKer
            </DialogTitle>
            <DialogContent>
                <Box style={{padding: '1.5rem 0rem 0rem 0rem'}}>
                    {isloader && <Loader></Loader>}
                    <Grid container spacing = {1}>
                        <Grid item xs={6} sm={6}>
                            <CustomTextField placeHolder='Name *' value={name} setFunc={(value) => {setName(value)}}></CustomTextField>
                            <Typography style={{...errorStyleText}}>{nameError}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <CustomTextField placeHolder='Contact Number *' value={contactNumber} setFunc={updateContactnumber}></CustomTextField>
                            <Typography style={{...errorStyleText}}>{contactError}</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <CustomDropDown placeHolder='Gender *' list={genderList} value={gender} setFunc={(value) => {setGender(value)}}></CustomDropDown>
                            <Typography style={{...errorStyleText}}>{genderError}</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <CustomDropDown placeHolder='Obligation *' list={obligationList} value={obligation} setFunc={(value) => {setObligation(value)}}></CustomDropDown>
                            <Typography style={{...errorStyleText}}>{obligationError}</Typography>
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <CustomTextField placeHolder='id' value={id} setFunc={updateId}></CustomTextField>
                            <Typography style={{...errorStyleText}}>{idError}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <CustomDropDown placeHolder='State *' list={stateList} value={selectedState} setFunc={(value) => {setSelectedState(value)}}></CustomDropDown>
                            <Typography style={{...errorStyleText}}>{selectedStateError}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <CustomDropDown placeHolder='District *' list={districtsList} value={selectedDistrict} setFunc={(value) => {setSelectedDistrict(value)}}></CustomDropDown>
                            <Typography style={{...errorStyleText}}>{selectedDistrictError}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} style={{display: 'flex', flexDirection: 'row'}}>
                            <Checkbox style={{padding: '0rem'}} checked={isDistrictHead} onClick={() => setIsDistrictHead(!isDistrictHead)}></Checkbox>
                            <Typography style={{color: headingBlue}}>District Head</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} style={{display: 'flex', flexDirection: 'row'}}>
                            <Checkbox style={{padding: '0rem'}} checked={isStateHead} onClick={() => setIsStateHead(!isStateHead)}></Checkbox>
                            <Typography style={{color: headingBlue}}>State Head</Typography>
                        </Grid>

                    </Grid>
                    <Box style={{padding: '1rem 0rem 0rem 0rem', display: 'flex', justifyContent: 'center'}}>
                        <Button style={{...buttonStyle, padding: '0.2rem 0.4rem', backgroundColor: red}}
                          onClick={() => props.updateFunc(false)}
                        > Cancel</Button>
                        <Button style={{...buttonStyle, padding: '0.2rem 0.4rem'}}
                          onClick={() => addWORKer()}
                        > Add</Button>
                    </Box>

                    <Box style={{display: 'flex', justifyContent: 'center', padding: '1rem 0rem 0rem 0rem'}}>
                      <Typography style={{...errorStyleText, fontSize: '0.85rem'}}>{apiError}</Typography>
                    </Box>
                </Box>
            </DialogContent>

        </Dialog>
    </>
  )
}

export default AddNewWORKer